import React, { FC } from 'react';
import classNames from 'classnames';

import { TEXTS } from 'application/pages/texts';

import IconHelpCircle from '@zvuk-b2b/react-uikit/ui/icons/HelpCircle';

import { getStreamDescription, getPlayerDescription } from './utils';
import { PointItemContentType } from './types';

import styles from './index.module.scss';

const ItemContent: FC<PointItemContentType> = ({
  className,
  showStreamData,
  isLoading,
  currentItem,
  showHint,
  hintIconNearSelector = false,
  disabled,
}) => (
  <div className={classNames(styles.content, showStreamData && styles.fullContent, className)}>
    <strong
      data-loading={isLoading}
      className={classNames(styles.title, {
        [styles.titleDisabled]: disabled,
      })}>
      {!isLoading && (currentItem?.title || currentItem?.address)}
    </strong>

    {showStreamData && (
      <>
        <span
          data-loading={isLoading}
          className={classNames(styles.secondaryText, {
            [styles.secondaryTextDisabled]: disabled,
          })}>
          {!isLoading && currentItem && getStreamDescription(currentItem.stream?.title)}
        </span>

        <span
          data-loading={isLoading}
          className={classNames(styles.secondaryText, {
            [styles.secondaryTextDisabled]: disabled,
            [styles.secondaryTextWarning]: !currentItem?.device,
          })}>
          {!isLoading && (
            <>
              {`${TEXTS.MODAL_BIND_DEVICE_TYPE}: `}
              {currentItem && getPlayerDescription(currentItem.device?.type)}
            </>
          )}
        </span>
      </>
    )}

    {showHint && (
      <span
        id="point_item_content_hint"
        className={styles.popperWrapper}>
        <IconHelpCircle
          className={classNames({
            [styles.popperWrapperIcon]: hintIconNearSelector,
          })}
        />
      </span>
    )}
  </div>
);

export default React.memo(ItemContent);
